import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import './styles.scss'
import { ErrorMessage } from '../ErrorMessage'
import { RequiredSpan } from '../RequiredSpan'

const PADDING = 2

export class TextArea extends React.Component {
  constructor (props) {
    super(props)
    this.focus = this.focus.bind(this)
  }

  componentDidMount () {
    this.updateHeight()
  }

  componentDidUpdate () {
    this.updateHeight()
  }

  focus () {
    this.textArea.focus()
  }

  updateHeight () {
    const textarea = this.textArea
    if (textarea) {
      const previous = window.scrollY
      textarea.style.height = '0'
      textarea.style.height = `${textarea.scrollHeight + PADDING * 2}px`
      const current = window.scrollY
      if (previous !== current) {
        window.scrollY = previous
      }
    }
  }

  renderRequired () {
    const { required } = this.props
    if (!required) {
      return <div />
    }
    return <RequiredSpan />
  }

  render () {
    const {
      label,
      errors,
      name,
      onKeyPress,
      onBlur,
      onChange,
      onFocus,
      required,
      value,
      disabled,
      onKeyUp,
      onKeyDown,
      staticLabel
    } = this.props

    return (
      <div
        className={cx('nh-text-area-container', {
          error: errors?.length
        })}
      >
        <textarea
          ref={input => {
            this.textArea = input
          }}
          className={cx({
            static: staticLabel
          })}
          onKeyUp={onKeyUp}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          required={required}
          value={value}
          disabled={disabled}
        />
        <span className='bar' />
        <label>{label}</label>
        {this.renderRequired()}
        <ErrorMessage errors={errors} />
      </div>
    )
  }
}

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool
}
